import "./FaqData.scss";

import React, { useState } from 'react';
import { FaqDataProps, FaqProps } from "./FaqDataTypes";
import { postApiCreateFaq, putApiUpdateFaq } from "../../../services/apiFaq";
import InputText from "../../InputText/InputText";
import Button from "../../Button/Button";
import {
  BtnBold,
  BtnBulletList,
  BtnItalic,
  BtnLink,
  BtnUnderline,
  Editor,
  EditorProvider,
  Toolbar
} from 'react-simple-wysiwyg';
import { useNavigate } from "react-router-dom";

const FaqData = (FaqDataProps: FaqDataProps): React.ReactElement => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState<boolean>(false);
  const [faq, setFaq] = useState<FaqProps>(FaqDataProps.faq);
  const [formErrors, setFormErrors] = useState<any>({});

  const saveFaqData = async (): Promise<void> => {
    setSaving(true);
    let error = false;
    setFormErrors({});

    if (!faq.question) {
      setFormErrors((prev: any) => ({ ...prev, question: "La pregunta es obligatoria" }));
      error = true;
    }
    if (!faq.answer) {
      setFormErrors((prev: any) => ({ ...prev, answer: "La respuesta es obligatoria" }));
      error = true;
    }

    if (error) {
      setFormErrors((prev: any) => ({ ...prev, form: "Hay errores en el formulario" }));
      setSaving(false);
      return;
    }

    const attributes: any = {
      faq: {
        question: faq.question,
        answer: faq.answer
      }
    };

    try {
      if (faq._id && faq._id !== '') {
        attributes.faq._id = faq._id;
        await putApiUpdateFaq(attributes);
      } else {
        await postApiCreateFaq(attributes);
      }
      setSaving(false);
      navigate('/faqs');
    } catch (err: any) {
      setSaving(false);
      console.log(err.message);
    }
  };

  return (
    <React.Fragment>
      <div className="row mb-5">
        <div className="col-12 my-3">
          <InputText
            label="Pregunta *"
            placeholder="¿Cómo funciona...?"
            value={faq.question}
            onChange={(event: any) => setFaq({ ...faq, question: event.currentTarget.value })} />
          {formErrors.question && <p className="error">{formErrors.question}</p>}
        </div>

        <div className="col-12 my-3">
          <label className="mb-2">Respuesta *</label>
          <EditorProvider>
            <Editor
              value={faq.answer ? faq.answer.replaceAll('&lt;', '<') : ''}
              onChange={(event: any) => setFaq({ ...faq, answer: event.target.value })}>
              <Toolbar>
                <BtnBold />
                <BtnItalic />
                <BtnUnderline />
                <BtnBulletList />
                <BtnLink />
              </Toolbar>
            </Editor>
          </EditorProvider>
          {formErrors.answer && <p className="error">{formErrors.answer}</p>}
        </div>
      </div>

      <div className="row pb-5">
        <div className="col text-center">
          {formErrors.form && <p className="error">{formErrors.form}</p>}
          <Button value="Guardar" className="btn-orange mx-auto" onClick={saveFaqData} iconRight={saving ? 'loaderIcon' : ''} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default FaqData;
